import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PlatformService } from 'src/app/_services/platform.service';
import { SharedModule } from 'src/app/_shared/_shared.module';

@Component({
  selector: 'app-landing-header',
  standalone: true,
  imports: [SharedModule, RouterModule],
  templateUrl: './landing-header.component.html',
  styleUrl: './landing-header.component.scss'
})
export class LandingHeaderComponent {
  @Input() landingPage: 'index' | 'registro';
  @Input() returnUrl: string;
  domainUrlCreative: string;

  constructor(private _platformService: PlatformService) {
    this.domainUrlCreative = this._platformService.getSubdominioUrl('creative');
  }

}
